import api from '../../../../../../admin/api/api';

export default {
	namespaced: true,
    state: {
        messages: [],
    },
    mutations: {
        setMessages(state, messages) {
            state.messages = messages;
        },
        addMessage(state, message) {
            const existMessage = _.findIndex(state.messages, ['id', message.id]);

            if (!(existMessage + 1)) {
                state.messages.push(message);
            }
        }
    },
    actions: {
        getMessages({commit, state}) {
			api.get('/chat/' + window.laravel.consultation.id)
				.then((response) => {
					commit('setMessages', response.data);
				})
				.catch((error) => {
					alert(error);
				});
        },
		sendMessage({commit, state}, data){
			api.post('/chat/' + window.laravel.consultation.id, data)
				.then((response) => {
					commit('addMessage', response.data);
				})
				.catch((error) => {
					alert(error);
				});
        }
    }
}
